<template>
  <div>
    <template>
      <v-layout class="mt-3">
        <v-flex xs4>
          <div>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="gray" outline v-on="on">
                  {{ filter.job }}
                  <i
                    class="fa fa-sort-desc ml-2"
                    style="font-size: 16px; margin-bottom: 6px"
                    aria-hidden="true"
                  />
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in typeOptions"
                  :key="index"
                  @click="onChangeJob(item)"
                >
                  <v-list-tile-title>{{ item }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-flex>
        <v-flex xs8 class="text-xs-right">
          <v-btn outline color="primary" @click="onAddEmployee" :loading="loading">
            <v-icon>add</v-icon>
            <span>เพิ่มรหัสพนักงาน</span>
          </v-btn>
          <v-btn @click="showSearch" color="primary">
            <v-icon>search</v-icon> {{ $t('advanced search') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-data-table
        :loading="loading"
        v-model="selected"
        :headers="headers"
        :items="data"
        :pagination.sync="pagination"
        item-key="name"
        class="elevation-1 mt-3"
      >
        <!-- hide-actions -->
        <template v-slot:items="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td v-if="props.item.first_name">
              {{ props.item.first_name }} {{ props.item.last_name }}
            </td>
            <td v-else>-</td>

            <td>{{ props.item.employeeid || '-' }}</td>
            <td>{{ props.item.job || '-' }}</td>
            <td>{{ props.item.phoneno || '-' }}</td>
            <td>{{ props.item.location || '-' }}</td>
            <td>{{ props.item.branch || '-' }}</td>
            <td>
              <v-btn
                depressed
                color="primary"
                :disabled="!props.item.first_name"
                @click="onUnlinkAccount(props.item)"
              >
                <span style="font-size: 13px">ยกเลิกการผูกบัญชี</span>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="searchDialog" persistent width="650px">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="searchDialog = false" icon> <v-icon>close</v-icon></v-btn>
        </div>
        <div class="px-3 pb-4">
          <v-layout row wrap>
            <v-flex xs12 class="form-control">
              <div>ชื่อลูกค้า</div>
              <input v-model="filter.name" type="text" />
            </v-flex>
            <v-flex xs6 class="form-control pr-1">
              <div>ร้าน</div>
              <input v-model="filter.location" type="text" />
            </v-flex>
            <v-flex xs6 class="form-control">
              <div>สาขา</div>
              <input v-model="filter.branch" type="text"
            /></v-flex>
            <v-flex xs6 class="form-control pl-1">
              <div>เบอร์โทรศัพท์</div>
              <input v-model="filter.phoneno" type="text"
            /></v-flex>
          </v-layout>
          <div class="text-xs-center px-5">
            <v-btn :loading="loading" @click="onSearch" color="primary" depressed block>{{
              $t('Search')
            }}</v-btn>
            <v-btn @click="clearSearch" block flat>{{ $t('Clear Search') }}</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="employeeManamentDialog" persistent width="400px">
      <v-card class="pa-3">
        <h6 class="headline pb-3">เพิ่มรหัสพนักงาน</h6>
        <v-layout wrap>
          <v-flex xs12 class="form-control">
            <div>รหัสพนักงาน</div>
            <input v-model="input.employeeId" type="number" />
          </v-flex>
          <v-flex class="text-xs-center mt-3">
            <div>
              <v-btn outline color="grey" @click="onCloseAddEmployee">{{ $t('cancel') }}</v-btn>
              <v-btn depressed color="primary" :loading="saveloading" @click="saveEmployee">{{
                $t('Save')
              }}</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      search: '',
      detailToggle: false,
      pagination: {
        rowsPerPage: 25
      },
      selected: [],
      headers: [
        { text: 'ชื่อ', value: 'name', width: '5%', sortable: false },
        { text: 'รหัสพนักงาน', value: 'employeeid', width: '1%', sortable: false },
        { text: 'ตำแหน่ง', value: 'job', width: '1%', sortable: false },
        { text: 'เบอร์ติดต่อ', value: 'phoneno', width: '1%', sortable: false },
        { text: 'ร้าน', value: 'location', width: '1%', sortable: false },
        { text: 'สาขา', value: 'branch', width: '1%', sortable: false },
        { text: '', value: '', width: '1%', sortable: false }
      ],
      data: [],
      filter: {
        name: '',
        job: 'ทั้งหมด',
        phoneno: '',
        location: '',
        branch: ''
      },
      searchDialog: false,
      loading: false,
      employeeManamentDialog: false,
      input: {
        employeeId: ''
      },
      saveloading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    typeOptions() {
      var jobs = [...new Set(this.data.map((el) => el.job))].filter((el) => el)
      return ['ทั้งหมด', `Sales`, `PC`, 'ช่าง', 'ช่าง (SCG)']
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onChangeJob(item) {
      this.filter.job = item
      this.getData()
    },
    onSearch() {
      this.searchDialog = false
      this.getData()
    },
    showSearch() {
      this.searchDialog = true
    },
    clearSearch() {
      this.filter = {
        name: '',
        phoneno: '',
        location: '',
        branch: ''
      }
      this.getData()
      this.searchDialog = false
    },
    getData() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        ...this.filter
      }
      if (this.filter.job === 'ทั้งหมด') {
        data.job = ''
      }
      api.kingkitchengetemployee(data, (err, response) => {
        this.data = response.data
        this.loading = false
      })
    },
    closeDetailToggle() {
      this.detailToggle = false
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    saveEmployee() {
      if (this.input.employeeId == '') {
        this.$swal.fire({
          text: 'กรุณากรอกรหัสพนักงาน'
        })
      } else {
        let data = {
          employeeid: this.input.employeeId,
          pageid: this.selectedBot.pageid
        }

        this.saveloading = true
        api.kingkitchenAddEmployeeId(data, (err, response) => {
          this.saveloading = false
          if (response && response.responsecode == 200) {
            this.$swal.fire({
              type: 'success',
              title: this.$t('Success')
            })
            this.onCloseAddEmployee()
            this.getData()
          }
        })
      }
    },
    onAddEmployee() {
      this.employeeManamentDialog = true
    },
    onCloseAddEmployee() {
      this.input = {
        employeeId: ''
      }
      this.employeeManamentDialog = false
    },
    onUnlinkAccount(item) {
      let vm = this
      vm.$swal
        .fire({
          title: 'ยืนยันการยกเลิกการผูกบัญชี ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            let empId = item.employeeid
            let data = {
              employeeid: empId,
              pageid: vm.selectedBot.pageid
            }
            api.kingkitchenUnlinkMember(data, (err, response) => {
              if (err) {
                reject()
                return
              }

              if (response && response.responsecode == 200) {
                vm.$swal.fire({
                  type: 'success',
                  title: this.$t('Success')
                })
                vm.getData()
              }
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/member/Employee.vue